import { StringParam, useQueryParams } from 'use-query-params';
import { URL_KEY } from '@auth_module/constants/urlKeys';

export const useAuthParams = () => {
  return useQueryParams({
    [URL_KEY.register_invite_token]: StringParam,
    [URL_KEY.token]: StringParam,
    [URL_KEY.email]: StringParam,
    [URL_KEY.adc_logout]: StringParam,
    [URL_KEY.cid]: StringParam,
  });
};
